var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyRecive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 15.75,
    fill: "#F6EFFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.959 15.9706H28.149C27.9827 15.7344 27.8077 15.5156 27.624 15.2969L26.959 15.9706Z",
    fill: "#A461D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.705 14.3688C26.4863 14.185 26.2675 14.01 26.0312 13.8438V15.0337L26.705 14.3688Z",
    fill: "#A461D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6326 15.2967L30.2138 12.7155C30.4676 12.4617 30.4676 12.0417 30.2138 11.788C29.9601 11.5342 29.5401 11.5342 29.2863 11.788L26.7051 14.3692C27.0376 14.658 27.3438 14.973 27.6326 15.2967Z",
    fill: "#A461D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0308 13.125C26.0308 12.7662 25.7333 12.4688 25.3746 12.4688C25.0246 12.4688 24.7446 12.7488 24.7271 13.09C25.1821 13.3087 25.6196 13.5537 26.0308 13.8425V13.125Z",
    fill: "#A461D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5309 16.625C29.5309 16.2662 29.2334 15.9688 28.8747 15.9688H28.1484C28.4372 16.38 28.6909 16.8175 28.9009 17.2725C29.2509 17.255 29.5309 16.975 29.5309 16.625Z",
    fill: "#A461D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6562 23.4055H21.9188C22.26 23.4055 22.5312 23.0992 22.5312 22.723C22.5312 22.2505 22.4 22.1805 22.1025 22.0755L21.6562 21.918V23.4055Z",
    fill: "#A461D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.91 17.2725C28.9012 17.2725 28.8925 17.2812 28.875 17.2812H25.375C25.2875 17.2812 25.2087 17.2637 25.1212 17.2287C24.9637 17.1587 24.8325 17.0362 24.7625 16.87C24.7362 16.7912 24.7187 16.7125 24.7187 16.625V13.125C24.7187 13.1162 24.7275 13.1075 24.7275 13.09C23.59 12.5562 22.33 12.25 21 12.25C16.17 12.25 12.25 16.17 12.25 21C12.25 25.83 16.17 29.75 21 29.75C25.83 29.75 29.75 25.83 29.75 21C29.75 19.67 29.4437 18.41 28.91 17.2725ZM22.5312 20.8425C23.0912 21.035 23.8437 21.4462 23.8437 22.7325C23.8437 23.8262 22.9775 24.7275 21.9187 24.7275H21.6562V24.9462C21.6562 25.305 21.3587 25.6025 21 25.6025C20.6412 25.6025 20.3437 25.305 20.3437 24.9462V24.7275H20.2737C19.11 24.7275 18.1562 23.7475 18.1562 22.54C18.1562 22.1725 18.4537 21.875 18.8125 21.875C19.1712 21.875 19.4687 22.1725 19.4687 22.5312C19.4687 23.0125 19.8275 23.4062 20.2737 23.4062H20.3437V21.4637L19.4687 21.1575C18.9087 20.965 18.1562 20.5537 18.1562 19.2675C18.1562 18.1737 19.0225 17.2725 20.0812 17.2725H20.3437V17.0625C20.3437 16.7037 20.6412 16.4062 21 16.4062C21.3587 16.4062 21.6562 16.7037 21.6562 17.0625V17.2812H21.7262C22.89 17.2812 23.8437 18.2612 23.8437 19.4687C23.8437 19.8275 23.5462 20.125 23.1875 20.125C22.8287 20.125 22.5312 19.8275 22.5312 19.4687C22.5312 18.9875 22.1725 18.5937 21.7262 18.5937H21.6562V20.5362L22.5312 20.8425Z",
    fill: "#A461D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4688 19.2762C19.4688 19.7487 19.6 19.8188 19.8975 19.9238L20.3437 20.0812V18.5938H20.0812C19.7487 18.5938 19.4688 18.9 19.4688 19.2762Z",
    fill: "#A461D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyRecive);
export default __webpack_public_path__ + "static/media/money-recive.cbee75f232304d52cb913479eea7737e.svg";
export { ForwardRef as ReactComponent };